var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_7913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V20H28V0Z",
    fill: "url(#paint0_linear_1310_7913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H13.3333V20H28V0Z",
    fill: "url(#paint1_linear_1310_7913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 0H0V20H9.33333V0Z",
    fill: "url(#paint2_linear_1310_7913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 0H9.33331V20H18.6666V0Z",
    fill: "url(#paint3_linear_1310_7913)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1310_7913",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1310_7913",
    x1: 20.6666,
    y1: 0,
    x2: 20.6666,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1310_7913",
    x1: 4.66667,
    y1: 0,
    x2: 4.66667,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1035BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1310_7913",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_7913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/France.8abf4f3959a00ef19f89451bc128850f.svg";
export { ForwardRef as ReactComponent };